import type { PostView } from "../queries.ts";

export type ComposeIntent =
  | { readonly kind: "reply" | "quote"; readonly post: PostView }
  | { readonly kind: "edit"; readonly post: PostView; readonly onSaved: (post: PostView) => void };

const requests = new EventTarget();

export function requestCompose(intent: ComposeIntent): void {
  requests.dispatchEvent(new CustomEvent("compose", { detail: intent }));
}

export function onCompose(listener: (intent: ComposeIntent) => void, signal: AbortSignal): void {
  requests.addEventListener("compose", (event) => {
    listener((event as CustomEvent<ComposeIntent>).detail);
  }, { signal });
}
